export default __webpack_public_path__ + "static/media/cfte.0acaf9f3.png";